/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.BpmbuildDevelopmentappspotcom) {
      root.BpmbuildDevelopmentappspotcom = {};
    }
    root.BpmbuildDevelopmentappspotcom.ChartArea = factory(root.BpmbuildDevelopmentappspotcom.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The ChartArea model module.
   * @module model/ChartArea
   * @version 1.0.0
   */

  /**
   * Constructs a new <code>ChartArea</code>.
   * @alias module:model/ChartArea
   * @class
   */
  var exports = function() {
  };

  /**
   * Constructs a <code>ChartArea</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ChartArea} obj Optional instance to populate.
   * @return {module:model/ChartArea} The populated <code>ChartArea</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();
      if (data.hasOwnProperty('bottom'))
        obj.bottom = ApiClient.convertToType(data['bottom'], 'Number');
      if (data.hasOwnProperty('height'))
        obj.height = ApiClient.convertToType(data['height'], 'String');
      if (data.hasOwnProperty('left'))
        obj.left = ApiClient.convertToType(data['left'], 'Number');
      if (data.hasOwnProperty('right'))
        obj.right = ApiClient.convertToType(data['right'], 'Number');
      if (data.hasOwnProperty('top'))
        obj.top = ApiClient.convertToType(data['top'], 'Number');
      if (data.hasOwnProperty('width'))
        obj.width = ApiClient.convertToType(data['width'], 'String');
    }
    return obj;
  }

  /**
   * @member {Number} bottom
   */
  exports.prototype.bottom = undefined;

  /**
   * @member {String} height
   */
  exports.prototype.height = undefined;

  /**
   * @member {Number} left
   */
  exports.prototype.left = undefined;

  /**
   * @member {Number} right
   */
  exports.prototype.right = undefined;

  /**
   * @member {Number} top
   */
  exports.prototype.top = undefined;

  /**
   * @member {String} width
   */
  exports.prototype.width = undefined;

  return exports;

}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/model/ChartArea.js